import { useMemo } from 'react';
import { useSystemClassifierItems } from '../../../../configuration';
import { DataObjectDescriptionVersionStore } from '../../../DataObjectDescriptionVersionStore';
import { getAlgorithmTargetRuleOptions } from './getAlgorithmTargetRuleOptions';
import type { AlgorithmTargetMappingOptionsProps } from './types';

const { useValue } = DataObjectDescriptionVersionStore;

export const useAlgorithmTargetRuleOptions = (
  props: Omit<
    AlgorithmTargetMappingOptionsProps,
    | 'confidentialityStatusCode'
    | 'targetDimensionsAndIndicatorsByCode'
    | 'subjectAttributeCodes'
  >,
) => {
  const [confidentialityStatusCode] = useValue('confidentialityStatusCode');
  const [targetDimensionsAndIndicatorsByCode] = useValue(
    'targetDimensionsAndIndicatorsByCode',
  );
  const subjectAttributes = useSystemClassifierItems('DATA_SUBJECT_ATTRIBUTE');
  const subjectAttributeCodes = useMemo(
    () => subjectAttributes.map((item) => item.code),
    [subjectAttributes],
  );

  return useMemo(
    () =>
      getAlgorithmTargetRuleOptions({
        ...props,
        confidentialityStatusCode,
        targetDimensionsAndIndicatorsByCode,
        subjectAttributeCodes,
      }),
    [
      props,
      confidentialityStatusCode,
      targetDimensionsAndIndicatorsByCode,
      subjectAttributeCodes,
    ],
  );
};
